module.exports = __webpack_public_path__ + "ember.a679d0.svg";